// @flow

import React from 'react';
import { Helmet } from 'react-helmet';

export const Vendor = () => (
  <>
    <Helmet>
      <style>@import url(https://use.typekit.net/iux1ptq.css);</style>
      <link rel="preconnect" href={`https://www.google-analytics.com`} />
    </Helmet>
  </>
);

export default Vendor;
